import {Navigate, RouteObject} from 'react-router';
import {authGuard} from '@common/auth/guards/auth-route';

export const appAdminRoutes: RouteObject[] = [
  {
    path: 'score',
    loader: () => authGuard({permission: 'referrals.manage'}),
    lazy: async () => ({
      Component: (await import('@app/admin/referral/referral-admin-page'))
        .ReferralAdminPage,
    }),
  },
  // The page used to be Admin → Referral.
  {path: 'referral', element: <Navigate to="/admin/score" replace />},
];
